import React from 'react';
import Message from 'components/commercetools-ui/atoms/message';
import Preview from 'components/commercetools-ui/organisms/checkout/components/steps/previews/wrapper';
import Givex from 'components/commercetools-ui/organisms/checkout/components/steps/sections/payment/components/givex';
interface Props {
  paymentDescription: string;
  paymentError?: {
    result: boolean;
    message: string;
  };
}

const AmazonPaymentPreview: React.FC<Props> = ({
  paymentDescription,
  paymentError = { result: false, message: '' },
}) => {
  return (
    <>
      <Preview>
        {paymentError.result && (
          <>
            <div className="relative bg-white">
              <Message severity={'error'} message={paymentError.message}></Message>
            </div>
          </>
        )}
        <div className={`border border-neutral-400 p-16 md:px-20 md:py-24 `}>
          <div className="flex items-center justify-between border-l-4 border-ag_color-text_green py-18 pl-18 ">
            <div>{paymentDescription}</div>
          </div>
        </div>
      </Preview>
      <div className="mt-0 border border-t-0 border-neutral-400 bg-white px-20">
        <Givex></Givex>
      </div>
    </>
  );
};

export default AmazonPaymentPreview;
